import React from 'react';
import { connect } from 'react-redux';
import { CollectionsBucket } from '../../../../components/FeaturedCollections';
import { ConnectedProps, DiscoverState } from '../../../../types/index';

const CollectionsBucketContainer = (props: CollectionsBucketContainerProps) => {
    const { tld, placeId } = props;

    return <CollectionsBucket tld={tld} currentPlace={placeId || 'online'} />;
};

const _mapStateToProps = ({ app, location }: DiscoverState) => ({
    isFeLoading: app.loadingState && app.loadingState.isFeLoading,
    isBotRequest: app.isBotRequest,
    placeId: location.placeId,
    tld: app.tld,
});

type CollectionsBucketContainerProps = ConnectedProps<typeof _mapStateToProps>;
export default connect(_mapStateToProps)(CollectionsBucketContainer);
